export const verificatieBerekeningSelectOptions = {
    status: [
        { text: 'Definitief', value: '0' },
        { text: 'Concept', value: '1' },
    ],
    toetsing: [
        { text: 'Voldoet', value: '1' },
        { text: 'Voldoet niet', value: '6' },
    ],
    toetsNiveau: [
        { value: '0', text: 'Afkeur' },
        { value: '1', text: 'Gebruik' },
        { value: '2', text: 'Verbouw' },
        { value: '3', text: 'Nieuwbouw' },
    ],
    normVersie: [
        { value: '0', text: 'NEN 8700:2011/A1:2018 Ontw.' },
        { value: '1', text: 'NEN 8700:2011 & Eurocodes' },
        { value: '2', text: 'NEN 8700:2011 & NEN 6706' },
        { value: '3', text: 'NEN 6705 (zonder NEN 8700)' },
        { value: '4', text: 'VOSB 1995 - Klasse 60' },
        { value: '5', text: 'VOSB 1995 - Klasse 45' },
        { value: '6', text: 'VOSB 1995 - Klasse 30' },
        { value: '7', text: 'Anders, namelijk:' },
    ],
    modelleerNiveau: [
        { value: '0', text: '1' },
        { value: '1', text: '2' },
        { value: '2', text: '3' },
        { value: '3', text: '4' },
        { value: '4', text: '5' },
        { value: '5', text: '6' },
        { value: '6', text: '7' },
    ],
    wegindeling: [
        { value: '0', text: 'Bestaand (conform ontwerp)' },
        { value: '1', text: 'Bestaand (niet conform ontwerp)' },
        { value: '2', text: 'Beoogd (conform ontwerp)' },
        { value: '3', text: 'Beoogd (niet conform ontwerp)' },
        { value: '4', text: 'Vrij (conform ontwerp)' },
        { value: '5', text: 'Vrij (niet conform ontwerp)' },
    ],
    aantalZwareVoertuigenPerJaar: [
        { value: '0', text: '>= 2.000.000' },
        { value: '1', text: '700.000' },
        { value: '2', text: '500.000' },
        { value: '3', text: '200.000' },
        { value: '4', text: '125.000' },
        { value: '5', text: '50.000' },
        { value: '6', text: '20.000' },
        { value: '7', text: '2.000' },
        { value: '8', text: '<=200' },
        { value: '9', text: 'Anders, namelijk:' },
    ],

    beperkingVoertuigGewicht: [
        { value: '0', text: 'N.v.t.' },
        { value: '1', text: '50 ton' },
        { value: '2', text: '45 ton' },
        { value: '3', text: '40 ton' },
        { value: '4', text: '35 ton' },
        { value: '5', text: '30 ton' },
        { value: '6', text: '25 ton' },
        { value: '7', text: '20 ton' },
    ],
    beperkingAslast: [
        { value: '0', text: 'N.v.t.' },
        { value: '1', text: '10 ton' },
        { value: '2', text: '9 ton' },
        { value: '3', text: '8 ton' },
        { value: '4', text: '7 ton' },
        { value: '5', text: '6 ton' },
        { value: '6', text: '5 ton' },
        { value: '7', text: '4 ton' },
        { value: '8', text: '3 ton' },
    ],

    unityCheckType: [
        { value: '0', text: 'Moment' },
        { value: '1', text: 'Moment mxD+' },
        { value: '2', text: 'Moment mxD-' },
        { value: '3', text: 'Moment myD+' },
        { value: '4', text: 'Moment myD-' },
        { value: '5', text: 'Dwarskracht' },
        { value: '6', text: 'Dwarskracht vx+' },
        { value: '7', text: 'Dwarskracht vx-' },
        { value: '8', text: 'Dwarskracht vy+' },
        { value: '9', text: 'Dwarskracht vy1' },
        { value: '10', text: 'Normaalkracht (incl.knik)' },
        { value: '11', text: 'Von Mises spanning' },
        { value: '12', text: 'Kip' },
        { value: '13', text: 'Vermoeiing' },
        { value: '14', text: 'Geotechnisch draagvermogen' },
        { value: '15', text: 'Pons' },
        { value: '16', text: 'Stabiliteit (kantel)' },
        { value: '17', text: 'N-My-Mz' },
        { value: '18', text: 'Interactie' },
        { value: '19', text: 'Scheurwijdte' },
        { value: '20', text: 'spanningsbeperking' },
        { value: '21', text: 'Vervorming' },
        { value: '22', text: 'Moment, wringend' },
        { value: '23', text: 'Anders, namelijk' },
    ],
};
